import React from "react";
import { Link } from "@tanstack/react-router";
import { CTASection } from "../ui/cta-section";

interface BottomCTAProps {
  itemCount: number;
  itemTypePlural: string;
  breakdownName: string;
  breakdownTypeSlug: string;
  joinAsLinkUrl: string;
  joinAsLinkText: string;
  mainCtaSubTextTemplate: string;
  mainCtaButtonTextTemplate: string;
  utmCampaignPrefix: string;
}

export const BottomCTA = ({
  itemCount,
  itemTypePlural,
  breakdownName,
  breakdownTypeSlug,
  joinAsLinkUrl,
  joinAsLinkText,
  mainCtaSubTextTemplate,
  mainCtaButtonTextTemplate,
  utmCampaignPrefix,
}: BottomCTAProps) => {
  const mainCtaSubText = mainCtaSubTextTemplate.replace("{}", breakdownName);
  const mainCtaButtonText = mainCtaButtonTextTemplate.replace(
    "{}",
    breakdownName,
  );

  return (
    <div className="mt-12 flex flex-col items-center justify-center gap-4 text-center text-sm">
      <p className="text-text-secondary">
        {0 < itemCount
          ? `Showing ${itemCount} of our ${itemTypePlural} in ${breakdownName}.`
          : `Be the first ${breakdownName} ${itemTypePlural.slice(0, -1)} listed!`}{" "}
        <a
          href={joinAsLinkUrl}
          className="text-text-primary font-semibold underline transition-colors hover:no-underline"
        >
          {joinAsLinkText}
        </a>
      </p>
      <div className="w-full max-w-prose">
        <CTASection
          title={mainCtaSubText}
          linkText={mainCtaButtonText}
          link={`/discovery?utm_campaign=${utmCampaignPrefix}&utm_source=${breakdownTypeSlug}`}
        >
          <div className="mt-4">
            <Link
              to="/blog/members"
              className="text-brand-700 hover:text-brand-800 my-2 text-center text-xs underline transition-colors hover:no-underline"
            >
              How does Dream Coach Match work?
            </Link>
          </div>
        </CTASection>
      </div>
    </div>
  );
};

export default BottomCTA;
